import {
  ORDER_COUNT_ASSIGN_SUCCESS,
  ORDER_HISTORY_LIST_SUCCESS,
  ORDER_IMPORT_SUCCESS,
  ORDER_LIST_SUCCESS,
  ORDER_NEW_CARE_SUCCESS,
  ORDER_ONE_SUCCESS,
  ORDER_UPDATE_FILTER,
  ORDER_SAVE_SUCCESS,
  ORDER_UPDATE_HOMEPAGE_FILTER,
  ORDER_HOMEPAGE_LIST_SUCCESS,
  ORDER_HOMEPAGE_ONE_SUCCESS,
  ORDER_LIMIT_UPDATE_HOMEPAGE_FILTER,
  ORDER_LIMIT_HOMEPAGE_LIST_SUCCESS,
  ORDER_LIMIT_HOMEPAGE_ONE_SUCCESS,
  ORDER_HANDLE_IMPORT_ERRORS
} from 'src/actions/order.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageOrderFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageOrderPage: 0,
    homepageOrderLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageOrderLimitFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageOrderLimitPage: 0,
    homepageOrderLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageOrderItems: [],
  homepageOrderTotal: 0,
  homepageOrderSelected: undefined,
  homepageOrderLimitItems: [],
  homepageOrderLimitTotal: 0,
  homepageOrderLimitSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const orderReducer = (state = initState, action) => {
  switch (action.type) {
    case ORDER_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case ORDER_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageOrderFilter !== 'undefined' && state.homepageOrderFilter) {
        if (action.data.homepageOrderPage == 'no_update' && typeof state.homepageOrderFilter.homepageOrderPage !== 'undefined') action.data.homepageOrderPage = state.homepageOrderFilter.homepageOrderPage;
        if (action.data.homepageOrderLimit == 'no_update' && typeof state.homepageOrderFilter.homepageOrderLimit !== 'undefined') action.data.homepageOrderLimit = state.homepageOrderFilter.homepageOrderLimit;
      }
      return {
        ...state,
        homepageOrderFilter: action.data,
      }
    }
    case ORDER_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case ORDER_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageOrderItems: action.data.homepageOrderItems,
        homepageOrderTotal: action.data.homepageOrderTotal,
      }
    }
    case ORDER_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case ORDER_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageOrderSelected: action.data
      }
    }
    case ORDER_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageOrderLimitFilter !== 'undefined' && state.homepageOrderLimitFilter) {
        if (action.data.homepageOrderLimitPage == 'no_update' && typeof state.homepageOrderLimitFilter.homepageOrderLimitPage !== 'undefined') action.data.homepageOrderLimitPage = state.homepageOrderLimitFilter.homepageOrderLimitPage;
        if (action.data.homepageOrderLimitLimit == 'no_update' && typeof state.homepageOrderLimitFilter.homepageOrderLimitLimit !== 'undefined') action.data.homepageOrderLimitLimit = state.homepageOrderLimitFilter.homepageOrderLimitLimit;
      }
      return {
        ...state,
        homepageOrderLimitFilter: action.data,
      }
    }
    case ORDER_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageOrderLimitItems: action.data.homepageOrderLimitItems,
        homepageOrderLimitTotal: action.data.homepageOrderLimitTotal,
      }
    }
    case ORDER_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageOrderLimitSelected: action.data
      }
    }
    case ORDER_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case ORDER_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case ORDER_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case ORDER_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case ORDER_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case ORDER_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default orderReducer